import { z } from 'zod'

// ----- Multi-repo session schemas -----

/** Maximum number of repositories allowed per session */
export const MAX_REPOS_PER_SESSION = 5

/** Zod schema for a single repo entry in a multi-repo session */
export const repoInputSchema = z.object({
  repositoryName: z.string().min(1),
  installationId: z.number().int(),
  baseBranch: z.string().optional(),
})

export type RepoInput = z.infer<typeof repoInputSchema>

/** Zod schema for the repos array (min 1, max MAX_REPOS_PER_SESSION) */
export const reposArraySchema = z
  .array(repoInputSchema)
  .min(1, 'At least one repository is required')
  .max(
    MAX_REPOS_PER_SESSION,
    `Maximum ${MAX_REPOS_PER_SESSION} repositories per session`,
  )
